const inferEnv = (): "staging" | "sandbox" | "production" => {
  switch (true) {
    case window.location.hostname.indexOf("staging") > -1:
    case window.location.hostname.indexOf("localhost") > -1:
      return "staging";
    case window.location.hostname.indexOf("sandbox") > -1:
      return "sandbox";
    default:
      return "production";
  }
};

const basePaths = {
  staging: "https://api.staging.zimpler.net",
  sandbox: "https://api.sandbox.zimpler.net",
  production: "https://api.zimpler.net",
};

const proxyUrls = {
  sandbox: "https://brazil-frontend-proxy.sandbox.zimpler.net",
  staging: "https://brazil-frontend-proxy.staging.zimpler.net",
  production: "https://brazil-frontend-proxy.zimpler.net",
};

export const getRedirectUrl = (
  sessionId: string,
  type: "close" | "error" | "success",
  customReturnUrl?: string,
): string => {
  const redirect = `${customReturnUrl ?? basePaths[inferEnv()]}/v4/callbacks/:id/:outcome`;
  const url = redirect.replace(":id", sessionId).replace(":outcome", type);

  return url;
};

export const getAnalyticsUrl = (sessionId: string) => {
  return `${basePaths[inferEnv()]}/checkout/sessions/${sessionId}/za`;
};

export const getEventsUrl = (sessionId: string) => {
  return `${basePaths[inferEnv()]}/checkout/sessions/${sessionId}/events`;
};

export const getSessionId = (): string => {
  return new URLSearchParams(window.location.search).get("s") || window.location.pathname.replace("/", "");
};

export const getProxyUrl = (): string => {
  return proxyUrls[inferEnv()];
};
